module.exports = __webpack_public_path__ + "static/media/1.fefc3cd2.jpg";